import styled from '@emotion/styled';
import { Spacings, mediaQuery, Fonts } from '@styles/index';
import Image from '@base/Image';
import { useIsMobile } from '@stores/AppCommonData';
import H5 from '@base/H5/H5';
import P2 from '@base/P2/P2';
import StepProgressBar from './StepProgressBar';

const Container = styled.div`
  ${mediaQuery.aboveMobile} {
    background-color: var(--color-base-1);
  }
  ${mediaQuery.uptoMobile} {
    margin-top: ${Spacings.SPACING_1B};
  }
`;
const ProgressBar = styled.div`
  display: flex;
  flex-direction: row;
  background-color: var(--color-base-1);
  border: 1px solid var(--color-divider-secondary);
  border-radius: ${Spacings.SPACING_2B};
  flex: none;
  padding: ${Spacings.SPACING_4B};
  gap: ${Spacings.SPACING_4B};
  align-items: center;
`;

const LaptopReward = styled.div`
  position: relative;
  width: ${Spacings.SPACING_11B};
  height: ${Spacings.SPACING_10B};
`;

const ProgressContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
  ${mediaQuery.uptoMobile} {
    align-items: center;
  }
`;

const ProgressBarHeading = styled(H5)`
  font-family: AvertaStd, -apple-system, BlinkMacSystemFont, sans-serif;
  font-style: normal;
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.SMALL};
  }
`;

const TermsText = styled(P2)`
  color: var(--color-text-secondary);
`;

const StepProgress = ({ referralCount, minReferralRequired, label }) => {
  const isMobile = useIsMobile();
  return (
    <Container>
      <ProgressBar>
        {!isMobile && (
          <LaptopReward>
            <Image
              src="referrals/laptop_reward.svg"
              layout="fill"
              alt="avatar"
            />
          </LaptopReward>
        )}
        <ProgressContainer>
          <ProgressBarHeading>
            {!isMobile
              ? `${referralCount} of ${minReferralRequired} referrals completed for laptop`
              : `${referralCount} of ${minReferralRequired} referrals to win laptop`}
          </ProgressBarHeading>
          <StepProgressBar
            steps={minReferralRequired}
            currentSteps={referralCount}
          />
          {label && <TermsText>{label}</TermsText>}
        </ProgressContainer>
      </ProgressBar>
    </Container>
  );
};

export default StepProgress;
